<template>
    <comp-9-prep-adherence :section="9" :page="34" :nextDisabled="nextDisabled">
        <p>
            Put a checkmark next to any reasons that could make it hard for you to stay committed to taking PrEP on a regular basis. Feel free to also add some
            reasons of your own.
        </p>
        <v-checkbox
            v-for="barrier in prepBarriers"
            :key="barrier.id"
            :label="barrier.text"
            :value="barrier.id"
            v-model="selectedBarriers"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedBarrierResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedBarriers: [],
            selectedBarrierResponse: null
        };
    },
    computed: {
        prepSelectedBarriers() {
            let prepSelectedBarriers = map(filter(this.prepBarriers, 'selected'), 'id');

            if (prepSelectedBarriers) {
                return prepSelectedBarriers;
            } else return [];
        },
        prepSelectedBarrierResponse() {
            let userEnteredBarrier = filter(filter(this.prepBarriers, 'selected'), 'userEntered');

            if (userEnteredBarrier.length > 0) {
                return userEnteredBarrier[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.prepBarriers, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        prepBarriers: sync('section9/prepBarriers')
    },
    methods: {
        nextDisabled() {
            if (this.selectedBarriers.length === 0 || (this.showManualResponse && !this.selectedBarrierResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedBarriers() {
            forEach(this.prepBarriers, o => {
                if (this.selectedBarriers.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedBarrierResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedBarrierResponse() {
            forEach(this.prepBarriers, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedBarrierResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedBarriers = this.prepSelectedBarriers;
        this.selectedBarrierResponse = this.prepSelectedBarrierResponse;
    }
};
</script>
